export default {
      id: "unit_dashboard__mileage-usage",
      viewBox: "0 0 41 41",
      url: __webpack_public_path__ + "img/icons.svg#unit_dashboard__mileage",
      toString: function () {
        return this.url;
      }
    }